import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './MultiSelectInput.css'
import {asField} from '$src/common/forms'
import {MultiSelect} from 'react-selectize'
import 'react-selectize/dist/index.min.css'

interface Props {
  css?: any
  name: string
  label: string
  placeholder?: string
  value: any[]
  style?: 'normal' | 'big'
  options: Array<{label: string; value: string}>
  onChange: (v: any) => void
}

interface State {}

@observer
export default class MultiSelectInput extends Component<Props, State> {
  static Field: any

  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)
    const wholeValue = Array.isArray(props.value)
      ? props.options.filter(opt => props.value.includes(opt.value))
      : []

    return (
      <div {...classes('container', props.style || 'normal')}>
        <div {...classes('label')}>{props.label}</div>

        <MultiSelect
          // @ts-ignore
          style={{width: props.style === 'big' ? '409px' : '200px'}}
          options={props.options}
          placeholder="All options"
          values={wholeValue}
          onValuesChange={(s: Array<{label: string; value: any}>): void => {
            props.onChange(s.map(({value}) => value))
          }}
        />
      </div>
    )

    // return (
    //   <div {...classes('container')}>
    //     <div {...classes('label')}>{props.label}</div>

    //     {props.options.map(({label, value}) => {
    //       const isOn: boolean = wholeValue.indexOf(value) !== -1

    //       return (
    //         <label key={`label-${value}`} {...classes('item', isOn ? 'on' : '')}>
    //           <input
    //             type="checkbox"
    //             key={`value-${value}`}
    //             checked={isOn}
    //             onChange={(e: any) => {

    //               if (isOn) {
    //                 props.onChange(wholeValue.filter(v => v !== value))
    //               } else {
    //                 props.onChange(wholeValue.concat([value]))
    //               }
    //             }}
    //           />
    //           <div className={css.itemLabel}>{label}</div>
    //         </label>
    //       )
    //     })}
    //   </div>
    // )
  }
}
MultiSelectInput.Field = asField()(MultiSelectInput)



// WEBPACK FOOTER //
// ./src/common/MultiSelectInput.tsx